
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 135 172.32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M68.96 86.16H38.75C17.35 86.16 0 103.51 0 124.91v30.2c0 9.5 7.7 17.21 17.21 17.21h8.67c9.5 0 17.21-7.7 17.21-17.21v-8.67c0-9.5 7.7-17.21 17.21-17.21h8.67c9.5 0 17.21-7.7 17.21-17.21v-8.67c-.02-9.48-7.72-17.19-17.22-17.19z","fill":"#ff0090"}}),_c('path',{attrs:{"d":"M90.5 0H60.29c-9.5 0-17.21 7.7-17.21 17.21v8.67c0 9.5 7.7 17.21 17.21 17.21h8.67c9.5 0 17.21 7.7 17.21 17.21v8.67c0 9.5 7.7 17.21 17.21 17.21h8.67c9.5 0 17.21-7.7 17.21-17.21V38.75C129.24 17.35 111.9 0 90.5 0z","fill":"#404040"}})])
          )
        }
      }
    